import React from "react";

import { useGetSubscriptionQuery } from "../../../../features/api/customers";
import useAuthenticatedUserData from "../../../../hooks/useAuthenticatedUserData";

export default function UserInfo() {
  const { userDisplay } = useAuthenticatedUserData();
  const { data: subscription } = useGetSubscriptionQuery();

  let planName = "FREE PLAN";
  if (subscription) {
    if (subscription.status === "active") {
      if (import.meta.env.VITE_STARTER_SUBSCRIPTION_PRICE_IDS.split(",").includes(subscription.priceId)) {
        planName = "STARTER PLAN";
      } else if (import.meta.env.VITE_PRO_SUBSCRIPTION_PRICE_IDS.split(",").includes(subscription.priceId)) {
        planName = "PRO PLAN";
      }
    }
  }

  return (
    <div className="py-3">
      <p style={{ fontWeight: "600" }} className="mb-1 text-start">
        {userDisplay}
      </p>
      <p style={{ fontWeight: "600" }} className="text-start m-0">
        <small>{planName}</small>
      </p>
    </div>
  );
}
